import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import OrderHistoryState from "@store/Store/Pages/OrderHistory/OrderHistoryState";
import { Draft } from "immer";

const initialState: OrderHistoryState = {
    dirtyFilters: {},
    isFiltersModalOpen: false,
};

const reducer = {
    "Store/Pages/OrderHistory/UpdateDirtyFilters": (
        draft: Draft<OrderHistoryState>,
        action: { parameter: GetOrdersApiParameter },
    ) => {
        draft.dirtyFilters = { ...draft.dirtyFilters, ...action.parameter };
    },
    "Store/Pages/OrderHistory/ClearDirtyFilters": (draft: Draft<OrderHistoryState>) => {
        draft.dirtyFilters = { ...initialState.dirtyFilters };
    },
    "Store/Pages/OrderHistory/ToggleFiltersModalOpen": (draft: Draft<OrderHistoryState>) => {
        draft.isFiltersModalOpen = !draft.isFiltersModalOpen;
    },
};

const orderHistoryReducer = createTypedReducerWithImmer(initialState, reducer);
export default orderHistoryReducer;
